import script from "./RegisterDoneModal.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterDoneModal.vue?vue&type=script&setup=true&lang=js"

import "./RegisterDoneModal.vue?vue&type=style&index=0&id=bc85a950&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bc85a950"]])

export default __exports__